import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/process-section.tsx");
